<div class="mat-table-container">
  @if (containerState === ContainerState.onboard) {
    <div class="mat-table-container-onboard">
      <ng-content select="[onboard]"></ng-content>
    </div>
  }
  @if (containerState === ContainerState.noResult) {
    <div class="mat-table-container-no-results">
      <img
        class="no-results-illu"
        src="dist/tiime-material/assets/illu-no-results.svg"
        draggable="false"
        alt="Illustration aucun résultat"
      />
      <span class="no-results-label">Aucun Résultat</span>
    </div>
  }
  @if (containerState === ContainerState.contentPlaceholder) {
    <div class="mat-table-container-content-placeholder">
      @for (contentPlaceholderRow of contentPlaceholderRows; track trackByIndex($index)) {
        <div class="content-placeholder-row">
          <div>
            <div class="content-placeholder-cell first"></div>
            <div class="content-placeholder-cell"></div>
          </div>
          <div class="content-placeholder-cell last"></div>
        </div>
      }
    </div>
  }
  <ng-content select="[tiime-table]"></ng-content>
</div>
